export default __webpack_public_path__ + "static/media/delivery-truck.2e755246.svg";